import * as Animate from "react-reveal";
import { Link } from "react-router-dom";
import AvatarsImage from "../../../assets/images/png/avatar.webp";
import HeaderNavigation from "../../../components/layout/HeaderNavigation";
import HeaderTestimonySection from "./HeaderTestimonySection";

const IndividualButtonLink = () => {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={"https://api.whatsapp.com/send/?phone=12028217864"}
      className={`custom-btn custom-btn-with-shadow text-white bg-secondary pl-4 lg:pl-6 py-4 text-center rounded-lg mr-6 text-sm md:text-base  inline-flex items-center font-medium focus:outline-none mb-4`}
    >
      Send a message
      <span className="pl-8 lg:pl-12 pr-4 lg:pr-6">
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.5566 6.55658C11.864 6.24919 11.864 5.75081 11.5566 5.44342L6.54737 0.434209C6.23998 0.126819 5.7416 0.126819 5.43421 0.434209C5.12682 0.741599 5.12682 1.23998 5.43421 1.54737L9.88684 6L5.43421 10.4526C5.12682 10.76 5.12682 11.2584 5.43421 11.5658C5.7416 11.8732 6.23998 11.8732 6.54737 11.5658L11.5566 6.55658ZM0 6.78712H11V5.21288H0V6.78712Z"
            fill="white"
          />
        </svg>
      </span>
    </a>
  );
};

const BusinessButtonLink = () => {
  const handleClick = () => {
    if (typeof window !== "undefined") {
      window.document.getElementById("registration").scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`custom-btn custom-btn-with-shadow text-primary bg-white border border-secondary pl-4 lg:pl-6 py-4 text-center rounded-lg mr-6 text-sm md:text-base  inline-flex items-center font-medium focus:outline-none mb-4`}
    >
      Register now
      <span className="pl-8 lg:pl-12 pr-4 lg:pr-6">
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.5566 6.55658C11.864 6.24919 11.864 5.75081 11.5566 5.44342L6.54737 0.434209C6.23998 0.126819 5.7416 0.126819 5.43421 0.434209C5.12682 0.741599 5.12682 1.23998 5.43421 1.54737L9.88684 6L5.43421 10.4526C5.12682 10.76 5.12682 11.2584 5.43421 11.5658C5.7416 11.8732 6.23998 11.8732 6.54737 11.5658L11.5566 6.55658ZM0 6.78712H11V5.21288H0V6.78712Z"
            fill="#0003A9"
          />
        </svg>
      </span>
    </button>
  );
};

const HeaderSection = () => {
  return (
    <header className="pb-16 w-full relative home-header">
      <HeaderNavigation />

      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-between items-start">
          <div className="w-full lg:w-6/12 xl:w-5/12 pt-6 md:pt-14 pb-6 lg:pb-14">
            <Animate.Fade bottom>
              <h2 className="text-5xl leading-tight lg:text-[3.5rem] xl:text-[3.75rem] xl:leading-tight font-mono text-primary font-semibold pb-10 pt-8">
                I am Eyitayo.
                <br className="hidden md:block" />{" "}
                <br className="block md:hidden" />
                The Tech Bishop
              </h2>
            </Animate.Fade>

            <Animate.Fade bottom>
              <p className="w-full md:w-8/12 lg:w-10/12 xl:w-full text-default text-base md:text-lg md:leading-8 pb-10">
                I want to be your mentor and coach for the next 6 months.
                Together, we’ll unlock your drive, sharpen your execution
                skills, and help you become a highly effective and
                results-focused individual in tech!
              </p>
            </Animate.Fade>

            <Animate.Fade bottom>
              <div className="flex flex-wrap items-center w-full mt-2">
                <IndividualButtonLink />
                <BusinessButtonLink />
              </div>
            </Animate.Fade>

            <Animate.Fade bottom>
              <div className="flex flex-wrap items-center mt-6 lg:mt-10">
                <img
                  src={AvatarsImage}
                  alt="Avatar Images"
                  className="w-16 lg:w-20"
                />
                <p className="text-xs lg:text-sm ml-3">
                  Over 200K technology talents.{" "}
                  <Link to="/stories" className="font-medium text-primary">
                    Read stories
                  </Link>
                </p>
              </div>
            </Animate.Fade>
          </div>

          <div className="w-full lg:w-6/12 mx-auto xl:w-7/12 lg:block mt-4 lg:mt-6 xl:pl-16">
            <HeaderTestimonySection />
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderSection;
